import React, { Component } from 'react'
import { isEnv } from "@/config/index";
import { urlResolver } from '@/utils/commons';
import { checkisEnv } from '@/utils/utils'
import { queryAdvertUrl } from '@/api/api';
import { Toast } from '@/components';
import qs from 'qs'
export class wxad extends Component {
  state = {
    url:'https://mp.weixin.qq.com/s?__biz=MjM5ODMzOTYwMA==&mid=2650901697&idx=1&sn=6b16517688dbbdea4fc6f525b29e9e6d&scene=0#wechat_redirect',
    openid:'',
  }
  componentDidMount() {
    this.queryAdvertUrl()
  }
  queryAdvertUrl() {
    let url
    url = this.props.location.search;
    urlResolver(url);
    let query = {
      openId:this.props.location.state?this.props.location.openid:urlResolver(url).openId
    }
    queryAdvertUrl(query).then(({success,data}) => {
      if(success) {
        // Toast.info("请求接口")

        // if(localStorage.getItem('openIdkey') != 1) {
        //   localStorage.setItem('openIdkey',1)
          window.location.href = data
        // }else {
        //   localStorage.removeItem('openIdkey');
        //   window.wx.miniProgram.navigateTo({
        //     url: `pages/tab/index/index`
        //   })
        // }
      }else {
        // localStorage.removeItem('openIdkey');
        window.wx.miniProgram.navigateTo({
          url: `pages/tab/index/index`
        })
      }
    })
  }
  render() { 
    return (
      <div></div>
    )
  }
}

export default wxad